import { Badge, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useInfiniteFilterDashboardNotices } from "../../../../../common/api/queries";
import { PresetColors } from "../../../../../common/constants";

type Props = {
  showNoticesModal: VoidFunction;
};

export const DashboardNoticesButton = ({ showNoticesModal }: Props) => {
  const { t } = useTranslation();

  const { data } = useInfiniteFilterDashboardNotices();

  return (
    <Badge count={data?.pages[0]?.totalUnseenCount} color={PresetColors.BLUE}>
      <Button type="primary" size="large" onClick={showNoticesModal}>
        {t("dashboard.notices.actions.open")}
      </Button>
    </Badge>
  );
};
